import axiosClient from '../axiosClient';

export const getCalls = (params) => axiosClient.get('/admin/calls', { params });
